var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mvh100 padding-10 flex flex-col"},[_c('help-item',{staticClass:"flex-1",attrs:{"list":_vm.list,"type":"my"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }